/**
 * 「どちらのアプリを操作しているか」を本物の URL で言うための純関数（2026-10-04 console/plain-words-3・founder の直し）。
 *
 * WHY: 1 回目は 本番 / 開発 を「みんなが使うほう / 試すほう」と言い換えたが、founder に
 *   「みんなが使うキーとか、意味不明すぎるし、みんなからみえるのかなとかわけがわからない。抽象的にすることでどうとでも意味を持つようなことばにしないでください」
 *   と言われた。ぼんやりした造語ではなく、目に見える物 = そのアプリの本物の URL（neko-jump.kumodeck.app）で言う。
 * URL はサーバーの hosting の応答（GET …/environments/:env/hosting の url = hosting/paths.ts の hostingUrls）。
 *   公開していなくても返る（slug と配信ドメインから作る）。配信ドメインの無いサーバーでは null のことがある → URL 無しの文（_noUrl）にする。
 * import は型だけ（node --experimental-strip-types でそのまま読める）。
 */
import type { EnvName } from './api';

/** 画面に出す短い URL（https:// と最後の / を外す）。URL でない・長すぎる物は null（帯に変な文字を出さない） */
export function shortUrl(v: unknown): string | null {
  if (typeof v !== 'string' || v.length > 300) return null;
  try {
    const u = new URL(v);
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
    return (u.host + u.pathname).replace(/\/+$/, '');
  } catch {
    return null;
  }
}

/** URL を差し込む文のキー。URL が無ければ同じ意味で URL 無しの文（`…_noUrl`）を使う */
export function withUrlKey<K extends string>(key: K, url: string | null): { key: K | `${K}_noUrl`; vars: { url?: string } } {
  return url ? { key, vars: { url } } : { key: `${key}_noUrl`, vars: {} };
}

/** 両方のアプリの短い URL（ProjectShell が hosting の応答から作って ShellContext で配る） */
export type EnvUrls = Partial<Record<EnvName, string | null>>;
